import React from 'react'

import './Title.css';

function Title() {
  return (
    <div class="title">
      Tableau de Bord - Prix Gemeaux (2017-2020)
    </div>
  );
}

export default Title;
